import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const StyledTitleBlock = styled.div`
  width: 100%;
`;

const Description = styled.p`
  color: var(--soremo-gray);
`;

const TitleBlock = ({ title, description }) => {
  return (
    <StyledTitleBlock className="u-col u-gap8 u-mb8">
      <div className="heading-spacing-1824">{title}</div>
      {description ? <Description>{description}</Description> : null}
    </StyledTitleBlock>
  );
};

TitleBlock.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default TitleBlock;
